import MenuBar from "./MenuBar";

/**
 * The Layout component provides a container with a menu bar at the top and children components below.
 * @param {ReactNode} children - The content to be rendered inside the layout, typically the main page content.
 */
function Layout({ children }) {
  return (
    <>
      <MenuBar />
      {children}
    </>
  );
}

export default Layout;
